<script>
/**
 * ****************************************************************************
 * @description     :   Component for popup search workrequestcontents
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import { mapActions, mapState } from 'vuex';
import template from './template.html';
import MiddleSide from '../ra201000v/containers/middleSide';
import store from '@/store';
import ra201000vStore from '@/views/inquiry/ra201000v/store';

/**
 * Define component chat for popup search work request contents
 */

var ra201000v = {
    template: template,
    props: {
        onSelected: Function,
        initData: Object // initData.bukken_no, initData.ichiji_no
    },
    components: { MiddleSide },
    beforeCreate() {
        if (!store.hasModule('ra201000v')) {
            store.registerModule('ra201000v', ra201000vStore);
        }
    },
    created() {
        this.clearScreen();
    },
    data() {
        return {
            search: '',
            resultSearch: []
        };
    },
    computed: {
        initObject() {
            return this.initData;
        },
        ...mapState('ra201000v', ['condition'])
    },
    methods: {
        ...mapActions('app', ['showHeaderError', 'hideHeaderError']),
        ...mapActions('ra201000v', ['clearScreen']),
        doSelect(item) {
            if (this.onSelected) {
                this.onSelected(item);
            }
        }
    }
};
export default ra201000v;
</script>
<style lang="scss">
@import './style.scss';
</style>
